// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__372DT","requiredAsterisk":"Info_requiredAsterisk__1G5wt"};